import styled from 'styled-components';

export const StyledList = styled.ul`
  padding-left: 25px;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  font-weight: 300;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 0.4px;
  li {
    margin-bottom: 6px;
  }
`;

export const StyledPanel = styled.section`
  border: 1px solid #0a0b0d;
  border-radius: 6px;
  padding: 24px;
  margin: 10px 0 30px;
  max-width: 640px;
  background-color: #fcfcfc;
  @media only screen and (max-width: 991px) {
    padding: 18px;
  }
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const StyledField = styled.div`
  display: flex;
  flex-direction: column;
  font-family: 'Archivo', sans-serif;
  label {
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 6px;
  }
  input,
  textarea {
    font-family: 'Archivo', sans-serif;
    font-size: 16px;
    padding: 10px 12px;
    border: 1px solid ${({ invalid }) => (invalid ? '#c62828' : '#9e9e9e')};
    border-radius: 6px;
    background-color: #fff;
    color: #0a0b0d;
    width: 100%;
    box-sizing: border-box;
  }
  textarea {
    min-height: 110px;
    resize: vertical;
  }
`;

export const StyledHint = styled.span`
  font-family: 'Archivo', sans-serif;
  font-size: 14px;
  color: #555;
  margin-top: 4px;
`;

export const StyledError = styled.span`
  font-family: 'Archivo', sans-serif;
  font-size: 14px;
  color: #c62828;
  margin-top: 4px;
`;

export const StyledAlert = styled.div`
  font-family: 'Archivo', sans-serif;
  font-size: 16px;
  line-height: 26px;
  padding: 14px 16px;
  border-radius: 6px;
  margin-bottom: 18px;
  border: 1px solid ${({ tone }) => (tone === 'error' ? '#c62828' : '#2e7d32')};
  background-color: ${({ tone }) => (tone === 'error' ? '#fdecea' : '#edf7ed')};
  color: #0a0b0d;
`;

export const StyledSubmit = styled.button`
  align-self: flex-start;
  font-family: 'Archivo', sans-serif;
  font-weight: 700;
  font-size: 16px;
  padding: 12px 24px;
  border-radius: 6px;
  border: 1px solid #0a0b0d;
  background-color: #0a0b0d;
  color: #fff;
  cursor: pointer;
  min-width: 180px;
  &:disabled {
    opacity: 0.6;
    cursor: progress;
  }
`;

export const StyledLinkButton = styled.a`
  display: inline-block;
  font-family: 'Archivo', sans-serif;
  font-weight: 700;
  font-size: 16px;
  padding: 12px 24px;
  border-radius: 6px;
  border: 1px solid #0a0b0d;
  background-color: #0a0b0d;
  color: #fff !important;
  text-decoration: none;
  margin: 6px 0 14px;
`;

// Visually hidden, off-screen bot trap (not display:none, so naive bots still fill it).
export const StyledHoneypot = styled.div`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
